import { Component, ViewEncapsulation } from '@angular/core';
import { PortalMomentColumn, PortalMomentColumnDef, PortalMomentRow } from './models/reports';
import { portalMomentColumns } from './utils';
import { ReportSortablePanelV3Base } from './report-sortable-panel-v3.base';

@Component({
  moduleId: module.id.toString(),
  selector: 'report-portal-moments-panel-v3',
  templateUrl: './templates/report-sortable-panel-v3.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReportPortalMomentsPanelV3Component extends ReportSortablePanelV3Base<PortalMomentRow> {
  title: string = 'Portal Moments';
  columns: PortalMomentColumnDef[] = portalMomentColumns;
  labelColumnKey: string = PortalMomentColumn.MomentName;
}
